import { combineReducers } from "redux";

import googleSheetsAuthReducer from "./googleSheetsAuthUrlReducer";
import googleSheetsReducer from "./getGoogleSheetsReducer";
import googleSheetsWorksheetsReducer from "./getGoogleSheetWorksheetsReducer";
import updateGoogleSheetsConfigReducer from "./updateGoogleSheetsConfigReducer";
import hubspotAuthUrlReducer from "./hubspotAuthUrlReducer";
import hubspotDataReducer from "./getHubspotDataReducer";
import hubspotStatusReducer from "./getHubspotStatusReducer";
import hubspotTablesReducer from "./getHubspotTablesReducer";
import updateHubspotPropertyReducer from "./updateHubspotPropertyReducer";
import zapierAuthUrlReducer from "./zapierAuthUrlReducer";
import integrationStatusesReducer from "./integrationStatusesReducer";
import mailchimpAuthUrlReducer from "./mailchimpAuthUrlReducer";
import getMailchimpListsReducer from "./getMailchimpListsReducer";
import getMailchimpSelectedFieldsReducer from "./getMailchimpSelectedFieldsReducer";
import updateMailchimpConfig from "./updateMailchimpConfigReducer";
import zapierTokens from "./getZapierTokensReducer";
import zapierZapsReducer from "./zapierZapsReducer";

const integrationsReducer = combineReducers({
    sheets: combineReducers({
        auth: googleSheetsAuthReducer,
        data: googleSheetsReducer,
        worksheets: googleSheetsWorksheetsReducer,
        config: updateGoogleSheetsConfigReducer,
    }),

    hubspot: combineReducers({
        auth: hubspotAuthUrlReducer,
        data: hubspotDataReducer,
        status: hubspotStatusReducer,
        tables: hubspotTablesReducer,
        property: updateHubspotPropertyReducer,
    }),

    zapier: combineReducers({
        auth: zapierAuthUrlReducer,
        token: zapierTokens,
        zapsData: zapierZapsReducer,
    }),
    mailchimp: combineReducers({
        auth: mailchimpAuthUrlReducer,
        lists: getMailchimpListsReducer,
        selectedFields: getMailchimpSelectedFieldsReducer,
        config: updateMailchimpConfig,
    }),

    statuses: integrationStatusesReducer,
});

export default integrationsReducer;
